import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const assistantRunCompletedV1Schema = eventEnvelopeSchema.extend({
  userId: z.string().min(1).max(256),
  runId: z.string().min(1).max(256),
  threadId: z.string().min(1).max(256),
  durationMs: z.number().int().nonnegative().optional(),
  toolCount: z.number().int().nonnegative(),
});

export type AssistantRunCompletedV1 = z.infer<typeof assistantRunCompletedV1Schema>;

export const ASSISTANT_RUN_COMPLETED_V1_DETAIL_TYPE =
  'assistant.run-completed.v1' as const;
